import { OptionalAppOptions } from '@backstage/app-defaults';
import { ConfluenceIcon } from '../ConfluenceIcon';
import { TeamsIcon } from '../TeamsIcon';
import { JiraIcon } from '../JiraIcon';
import { PrometheusIcon } from '../PrometheusIcon';
import { ArgoIcon } from '../ArgoIcon';
import { VaultIcon } from '../VaultIcon';
import { WizIcon } from '../WizIcon';
import ScopeIcon from '@material-ui/icons/Archive';
import ProviderIcon from '@material-ui/icons/Store';
import ServiceIcon from '@material-ui/icons/ShoppingCart';
// A group in general is an Entra group, as on the page of a user.
import GroupIcon from '@material-ui/icons/VpnKey';
// A table rather than the DataHub mark the catalog actually runs on: the link
// is labelled by what it is, a data catalog, and the brand is not vendored
// here. A table is what the catalog lists.
import DataCatalogIcon from '@material-ui/icons/TableChart';
import { CmdbIcon } from '../CmdbIcon';
import { BlackboxExporterIcon } from '../BlackboxExporterIcon';
import { GitlabIcon } from '../GitlabIcon';
import { AirflowIcon } from '../AirflowIcon';
import { LeanIXIcon } from '../LeanIXIcon';
import { BackstageIcon } from '../BackstageIcon';
import { GrafanaIcon } from '../GrafanaIcon';
import { MLFlowIcon } from '../MLFlowIcon';
import { LangfuseIcon } from '../LangfuseIcon';

export const IconProvider: OptionalAppOptions['icons'] = {
  'kind:product': ScopeIcon,
  'kind:provider': ProviderIcon,
  'kind:service': ServiceIcon,
  'kind:group': GroupIcon,
  jira: JiraIcon,
  confluence: ConfluenceIcon,
  teams: TeamsIcon,
  prometheus: PrometheusIcon,
  argo: ArgoIcon,
  gitlab: GitlabIcon,
  cmdb: CmdbIcon,
  blackbox: BlackboxExporterIcon,
  airflow: AirflowIcon,
  leanix: LeanIXIcon,
  backstage: BackstageIcon,
  grafana: GrafanaIcon,
  langfuse: LangfuseIcon,
  mlflow: MLFlowIcon,
  vault: VaultIcon,
  wiz: WizIcon,
  'data-catalog': DataCatalogIcon,
};
